// extracted by mini-css-extract-plugin
export default {"circular-product-strip":"style_circular-product-strip__bzOiU"};